export function insertAtCursor(element: HTMLTextAreaElement, textToInsert: string): string {
    const { selectionStart, selectionEnd, value } = element;
    const beforeText = value.substring(0, selectionStart);
    const afterText = value.substring(selectionEnd);

    const spacePrefix = beforeText.length > 0 && !beforeText.endsWith(" ") ? " " : "";
    const spaceSuffix = afterText.length > 0 && !afterText.startsWith(" ") ? " " : "";

    return beforeText + spacePrefix + textToInsert + spaceSuffix + afterText;
}

export function setCaretPosition(element: HTMLTextAreaElement, position: number) {
    element.focus();
    element.setSelectionRange(position, position);
}
